import { render, staticRenderFns } from "./part5.vue?vue&type=template&id=53d8bb4f&"
import script from "./part5.vue?vue&type=script&lang=js&"
export * from "./part5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports